import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NewLesson from "./New";
import { NavigationDrawer } from "../Shared/Toolbox";
import Workspace from "../../types/Workspace";
import Dashboard from "../Dashboard/Dashboard";
import User from "../../types/User";
import Chat from "../Conversations/Chat";
import Sidebar from "./Sidebar";
import Show from "./Show";
import LessonsList from "./List";

export type StartProps = {
  user: User;
  workspace: Workspace;
}
 
const Start = (props: StartProps) => {

  const [prompt, setPrompt] = useState<string>("");
  const [sidebarOpen, showSidebar] = useState<boolean>(true);

  const { pathname } = useLocation();
  const { conversationId, lessonId } = useParams();
  const navigate = useNavigate();

  const openLesson = (lessonId: string) => {  
    navigate(`/lessons/${lessonId}`);
  };

  const renderSelectedContent = () => {
    switch(pathname) {
      case '/lessons/new':
        return <NewLesson onConversationCreate={(conversationId: string, prompt: string) => {
          setPrompt(prompt);
          navigate(`/conversations/${conversationId}`);
        }} />
      case `/conversations/${conversationId}`:
        return <Chat prompt={prompt} />
      case `/lessons/${lessonId}`:
        return <Show lessonId={lessonId!} user={props.user} />
      case `/lessons`:
        return <LessonsList {...props} onOpen={openLesson} />
      default:
        return <Dashboard />
    }
  }

  return <>
    <NavigationDrawer
        menu={<Sidebar {...props} 
                       open={sidebarOpen} 
                       onToggle={() => showSidebar(isOpen => !isOpen)} 
                       onOpen={openLesson} />} 
        currentContent={renderSelectedContent()}
        sx={{zIndex: 2, width: sidebarOpen ? "20vw" : "auto", boxShadow: "var(--box-shadow)", display: {xs: 'none', lg: 'flex'}}} />
  </>;
}

export default Start;